import React from "react";

const Logo = () => {
  return <span className="logo">ZG ✡</span>;
};

export default Logo;
